import L from "leaflet";

interface GeocodingResult {
  name: string;
  bbox: L.LatLngBounds;
  center: L.LatLng;
}

interface LocationIQOptions {
  serviceUrl?: string;
}

interface LocationIQData {
  lat: string;
  lon: string;
  display_name: string;
  boundingbox: string[];
}

type GeocoderCallback = (results: GeocodingResult[]) => void;

const LocationIQClass = L.Class.extend({
  options: {
    serviceUrl: "https://eu1.locationiq.com/v1/autocomplete.php",
  } as LocationIQOptions,

  initialize: function (key: string, options?: LocationIQOptions) {
    this._key = decodeURIComponent(key);
    L.Util.setOptions(this, options);
  },

  geocode: function (
    query: string,
    cb: GeocoderCallback,
    context: unknown
  ) {
    if (query.split(",").length === 2) {
      const lat = query.split(",")[0].trim();
      const lng = query.split(",")[1].trim();
      if (
        isFinite(Number(lat)) &&
        Math.abs(Number(lat)) <= 90 &&
        isFinite(Number(lng)) &&
        Math.abs(Number(lng)) <= 180
      ) {
        const latLng = L.latLng(Number(lat), Number(lng));
        const latLngBounds = L.latLngBounds(
          L.latLng(Number(lat), Number(lng)),
          L.latLng(Number(lat), Number(lng))
        );
        const result: GeocodingResult = {
          name: query,
          bbox: latLngBounds,
          center: latLng,
        };
        cb.call(context, [result]);
        return;
      }
    }

    this.getJSON(
      this.options.serviceUrl,
      { key: this._key, q: query },
      function (data: LocationIQData[] | "") {
        const results: GeocodingResult[] = [];
        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            const loc = data[i];
            const latLng = L.latLng(Number(loc.lat), Number(loc.lon));
            const latLngBounds = L.latLngBounds(
              L.latLng(Number(loc.boundingbox[0]), Number(loc.boundingbox[2])),
              L.latLng(Number(loc.boundingbox[1]), Number(loc.boundingbox[3]))
            );
            results[i] = {
              name: loc.display_name,
              bbox: latLngBounds,
              center: latLng,
            };
          }
        }

        cb.call(context, results);
      }
    );
  },

  suggest: function (
    query: string,
    cb: GeocoderCallback,
    context: unknown
  ) {
    return this.geocode(query, cb, context);
  },

  getJSON: function (
    url: string,
    params: Record<string, string>,
    callback: (data: LocationIQData[] | "") => void
  ) {
    const xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (xmlHttp.readyState !== 4) {
        return;
      }
      if (xmlHttp.status !== 200 && xmlHttp.status !== 304) {
        callback("");
        return;
      }
      callback(JSON.parse(xmlHttp.response));
    };
    xmlHttp.open("GET", url + L.Util.getParamString(params), true);
    xmlHttp.setRequestHeader("Accept", "application/json");
    xmlHttp.send(null);
  },
});

export const LocationIQ = LocationIQClass;
